import { render, staticRenderFns } from "./SealPrincess.vue?vue&type=template&id=5a8bb659&"
import script from "./SealPrincess.vue?vue&type=script&lang=js&"
export * from "./SealPrincess.vue?vue&type=script&lang=js&"
import style0 from "./SealPrincess.vue?vue&type=style&index=0&id=5a8bb659&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports